import React from "react";
import { useNavigate } from "react-router";

export default function ErrorPage() {
  setTimeout(() => {
    window.location.href = "/";
  }, 1800);

  return (
    <div className="grid h-screen place-items-center animate-pulse">
      <div className="mb-12">
        <h1 className="text-3xl font-bold">Something went wrong</h1>
        <p className="text-lg">Redirecting to home page...</p>
      </div>
    </div>
  );
}
